import React from 'react';
import FormGroup from "../forms/form_group";

const Checkbox = (props) => {
    return <FormGroup inputClasses={ ["checkbox"] } hint={ props.hint } offsetInput={ props.offsetInput }>
        <div>
            <label className="boolean optional">
                <input name={ props.name }
                       type="checkbox"
                       checked={ props.checked }
                       onChange={ props.onChange }
                       value={ props.value }
                       disabled={ props.disabled }
                       aria-describedby={ props.describedBy }
                />
                { props.children }
            </label>
            { props.afterLabel }
        </div>
    </FormGroup>
}

export default Checkbox
